import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import NavBar from "./blocks/NavBar";
import SideBar from "./blocks/SideBar";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Routes from './utils/routes';
import Login from './utils/Login';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Typography } from '@mui/material';
import PasswordReset from './utils/PasswordReset';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://589c9cc6806097ee0ea9992d1e7feba0@o4508205911900160.ingest.de.sentry.io/4509683486294096",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

const theme = createTheme({
    typography: {
        fontFamily: 'Roboto, Arial, sans-serif',
    },
});

const App = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem('token'));
    const [isPasswordReset, setIsPasswordReset] = useState(false);
    const [resetParams, setResetParams] = useState({ uidb64: null, token: null });

    const handleLogin = () => {
        if (!localStorage.getItem('token')) {
            setIsAuthenticated(false);
            window.location.href = '/login'; // Redirect to login page if no token is found

        }
        else {
            setIsAuthenticated(true); // Update authentication state
        }
    };

        
    useEffect(() => {
        if (!localStorage.getItem('token')) {
            setIsAuthenticated(false);
        }
    // axiosInstance(`/api/audit/${window.location.pathname.split('/').pop()}/`)
        const path = window.location.pathname;
        if (path.includes('reset-password')) {
            setIsPasswordReset(true);

            // Extract uidb64 and token from the URL
            const parts = path.split('/');
            const uidb64 = parts[2]; // Assuming the URL format is /reset-password/:uidb64/:token
            const token = parts[3];
            setResetParams({ uidb64, token });
            setIsPasswordReset(true);
        }
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
                {isAuthenticated ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
                        <NavBar />
                        <Grid container sx={{ flexGrow: 1, overflow: 'hidden' }}>
                            <Grid item sx={{ width: '12%' }}>
                                <SideBar />
                            </Grid>
                            <Grid
                                item
                                className="background-image-container"
                                sx={{
                                    flexGrow: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    overflowX: 'auto', // Explicitly handle horizontal scrolling
                                    overflowY: 'auto', // Explicitly handle vertical scrolling
                                    height: '100%',
                                    width: '88%',
                                }}
                            >
                                <Box
                                    sx={{
                                        flexGrow: 1,
                                        overflowX: 'auto', // Explicitly handle horizontal scrolling
                                        overflowY: 'auto', // Explicitly handle vertical scrolling
                                        p: 3,
                                    }}
                                >
                                    <Routes />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                ) : (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                        {isPasswordReset ? (
                            <PasswordReset uidb64={resetParams.uidb64} token={resetParams.token}  onLogin={handleLogin} />
                        ) : (
                            <Login onLogin={handleLogin} />
                        )}
                    </Box>
                )}
            </Router>
        </ThemeProvider>
    );
};

export default App;
